import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 82%;
    left: 50%;
    max-width: 1600px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
`;